module.exports = "/src/views/donate/main/elements/shop/img/char.png";